'use client';

import { c as _c } from "react/compiler-runtime";
import useIsMounted from '@module/utils/useIsMounted';
import AdultSwitchButton from './AdultSwitchButton';
import BroadcastStartButton from './broadcast/BroadcastStartButton';
import DarkModeButton from './DarkModeButton';
import MyNavMenuSSGContainer from './my-info/MyNavMenuSSGContainer';
import { NotificationMenu } from './notification/NotificationMenu';
import StoreButton from './StoreButton';
interface TopNavRightControlsProps {
  deferUntilMounted?: boolean;
  isCustomerPage?: boolean;
}
function TopNavRightControlsSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true" className="flex flex-nowrap items-center"><div className="h-[48px] w-[48px]" /><div className="mr-[7px] h-[40px] w-[120px]" /><div className="h-[48px] w-[48px]" /><div className="h-[48px] w-[48px]" /><div className="h-[48px] w-[48px]" /><div className="mr-2 h-[28px] w-[28px]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default function TopNavRightControls(t0) {
  const $ = _c(10);
  const {
    deferUntilMounted: t1,
    isCustomerPage
  } = t0;
  const deferUntilMounted = t1 === undefined ? false : t1;
  const isMounted = useIsMounted();
  if (deferUntilMounted && !isMounted) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <TopNavRightControlsSkeleton />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AdultSwitchButton />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isCustomerPage) {
    t3 = !isCustomerPage && <BroadcastStartButton>방송하기</BroadcastStartButton>;
    $[2] = isCustomerPage;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <StoreButton />;
    t5 = <NotificationMenu />;
    t6 = <DarkModeButton />;
    t7 = <MyNavMenuSSGContainer />;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t3) {
    t8 = <div className="flex flex-nowrap items-center">{t2}{t3}{t4}{t5}{t6}{t7}</div>;
    $[8] = t3;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}